import React, { memo } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceFit() {
  const isFor = ['Adultos de 50 a 75 años que se despiertan cansados cada mañana.', 'Personas que sufren de "mente acelerada" apenas tocan la almohada.', 'Quienes quieren dejar de depender de fármacos y soluciones químicas.', 'Hombres y mujeres que sienten que su memoria y energía han bajado por falta de descanso.'];
  const isNotFor = ['Personas que buscan una "pastilla mágica" sin cambiar ningún hábito.', 'Quienes no están dispuestos a apagar el televisor 30 minutos antes de dormir.', 'Menores de 30 años (sus necesidades hormonales son totalmente distintas).'];
  return <section className="py-24 bg-navy-900" data-id="element-53">
      <div className="max-w-6xl mx-auto px-6" data-id="element-54">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16" data-id="element-55">
          {/* Who is this for */}
          <FadeIn data-id="element-56">
            <div className="bg-navy-800 p-8 rounded-sm border border-navy-700 h-full" data-id="element-57">
              <h3 className="text-2xl font-serif text-cream mb-8 flex items-center gap-3" data-id="element-58">
                <span className="w-8 h-8 rounded-full bg-green-900/30 flex items-center justify-center" data-id="element-59">
                  <CheckIcon className="w-5 h-5 text-green-400" data-id="element-60" />
                </span>
                Para quién es esto
              </h3>
              <ul className="space-y-6" data-id="element-61">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-62">
                    <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-63" />
                    <span className="text-cream-muted leading-relaxed" data-id="element-64">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who is this NOT for */}
          <FadeIn delay={0.2} data-id="element-65">
            <div className="bg-navy-800 p-8 rounded-sm border border-navy-700 h-full opacity-80" data-id="element-66">
              <h3 className="text-2xl font-serif text-cream mb-8 flex items-center gap-3" data-id="element-67">
                <span className="w-8 h-8 rounded-full bg-red-900/30 flex items-center justify-center" data-id="element-68">
                  <XIcon className="w-5 h-5 text-red-400" data-id="element-69" />
                </span>
                Para quién NO es
              </h3>
              <ul className="space-y-6" data-id="element-70">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-71">
                    <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-72" />
                    <span className="text-cream-muted leading-relaxed" data-id="element-73">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}